import React, { useMemo } from 'react';
import { useMerchant, useMerchantTheme } from '@domain/merchants/queries';
import { useMerchantDisplayName, useMerchantImages } from '@domain/merchants/hooks';
import { SkeletonCircle, Image, Text } from '@chakra-ui/react';
import { ConditionalWrapper } from '@olo-web/components/atoms/Wrappers/ConditionalWrapper';
import { Link } from '@olo-web/components/atoms/Link';
import { useIsLevelup, useIsDineIn, useCurrentMerchantPath } from '@olo-web/utils/common/hooks';

type T = {
  isLogoClickable?: boolean;
};

export const BasicHeaderLogoOrName = ({ isLogoClickable = true }: T) => {
  const { logoUrl, logoAlt } = useMerchantImages();
  const { isLoading: merchantThemeLoading } = useMerchantTheme();
  const { isLoading: merchantLoading } = useMerchant();
  const merchantName = useMerchantDisplayName();
  const isLevelUp = useIsLevelup();
  const isDineIn = useIsDineIn();
  const path = useCurrentMerchantPath({
    includeQueryParam: !isDineIn,
  });

  const isLoading = useMemo(() => {
    return merchantThemeLoading || merchantLoading;
  }, [merchantThemeLoading, merchantLoading]);

  if (isLoading) return <SkeletonCircle />;
  return (
    <ConditionalWrapper
      condition={isLogoClickable && !isLevelUp}
      wrapper={(children) => <Link href={path}>{children}</Link>}
    >
      {logoUrl ? (
        <Image src={logoUrl} alt={logoAlt} maxW="80px" maxH={{ base: '40px', sm: '48px' }} />
      ) : (
        <Text
          noOfLines={1}
          textStyle={{ base: 'h4', sm: 'h3' }}
          _hover={isLogoClickable ? { textDecor: 'underline' } : undefined}
        >
          {merchantName}
        </Text>
      )}
    </ConditionalWrapper>
  );
};
